import React from "react";
import ReactDOM from "react-dom";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutline";

// Floating action pill anchored to the top-right of a hovered image / video.
// Hosts Edit and Delete buttons. Portaled so the editor's overflow rules
// can't clip it; positioned with `fixed` against the viewport.
const BADGE_WIDTH_ESTIMATE = 88;

const HoverEditBadge = ({
  rect,
  editLabel = "Edit",
  deleteLabel = "Delete",
  onEdit,
  onDelete,
  onMouseEnter,
  onMouseLeave,
}) => {
  const theme = useTheme();
  if (!rect) return null;

  const zIndex =
    theme.zIndex && theme.zIndex.modal ? theme.zIndex.modal - 1 : 9000;

  const top = rect.top + 8;
  const left = rect.right - BADGE_WIDTH_ESTIMATE - 8;

  const node = (
    <Box
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{
        position: "fixed",
        top: `${top}px`,
        left: `${left}px`,
        zIndex,
        display: "inline-flex",
        alignItems: "center",
        gap: "2px",
        padding: "2px",
        borderRadius: "6px",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        userSelect: "none",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.25)",
      }}
    >
      <Tooltip title={editLabel} placement="top" arrow>
        <IconButton
          onClick={onEdit}
          size="small"
          sx={{
            color: "#fff",
            padding: "4px",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
          }}
        >
          <EditIcon sx={{ fontSize: "16px" }} />
        </IconButton>
      </Tooltip>
      <Tooltip title={deleteLabel} placement="top" arrow>
        <IconButton
          onClick={onDelete}
          size="small"
          sx={{
            color: "#fff",
            padding: "4px",
            "&:hover": { backgroundColor: "rgba(255,80,80,0.4)" },
          }}
        >
          <DeleteIcon sx={{ fontSize: "16px" }} />
        </IconButton>
      </Tooltip>
    </Box>
  );

  return ReactDOM.createPortal(node, document.body);
};

export default HoverEditBadge;
